export const LESSON_CONTENT = {
  'lesson-1': {
    grade: 'الصف الخامس والسادس',
    unit: 'الوحدة التجريبية (3 دروس)',
    summary: 'في هذا الدرس نتعرف على كنوز مصر المعدنية وكيف تتكون المعادن وأين توجد وكيف تُستخدم في حياتنا اليومية.',
    objectives: [
      'تمييز أنواع المعادن الأساسية في مصر (ذهب، فوسفات، حديد، نحاس).',
      'تحديد أهم مناطق التعدين على خريطة مصر.',
      'فهم استخدامات المعادن في الصناعة والحياة اليومية.',
      'تعزيز مهارات الملاحظة والمقارنة بين أنواع المعادن.'
    ],
    sections: [
      {
        title: 'ما هي المعادن؟',
        paragraphs: [
          'المعادن مواد طبيعية تتكون داخل الأرض. بعضها لامع مثل الذهب، وبعضها صلب مثل الحديد.',
          'نستخرج المعادن من المناجم ثم تُستخدم في الصناعة والبناء وصناعة الأجهزة.'
        ],
        bullets: [
          'المعدن مورد طبيعي غير متجدد.',
          'يوجد المعدن في الصخور أو بالقرب من سطح الأرض.',
          'بعض المعادن نادرة وغالية الثمن.'
        ]
      },
      {
        title: 'أهم معادن مصر',
        paragraphs: [
          'تشتهر مصر بالذهب في منجم السكري، وبالفوسفات في أبو طرطور، والحديد في الواحات، والنحاس في سيناء.'
        ],
        bullets: [
          'الذهب: يستخدم في الحُلي والإلكترونيات.',
          'الفوسفات: يدخل في صناعة الأسمدة.',
          'الحديد: أساس البناء وصناعة السيارات.',
          'النحاس: ممتاز لتوصيل الكهرباء.'
        ]
      },
      {
        title: 'كيف نحافظ على الثروة المعدنية؟',
        paragraphs: [
          'لأن المعادن موارد غير متجددة، يجب استخدامها بحكمة مع إعادة التدوير وتقليل الفاقد.'
        ],
        bullets: [
          'إعادة تدوير المعادن توفر الطاقة.',
          'تقليل تلوث المناجم يحافظ على البيئة.',
          'التخطيط الجيد للاستغلال يحمي الأجيال القادمة.'
        ]
      },
      {
        title: 'المعادن حولنا',
        paragraphs: [
          'انظر حولك: أدوات المطبخ، الأسلاك، الهواتف، وحتى الأقلام تحتوي على معادن مفيدة.'
        ],
        bullets: [
          'الألومنيوم في علب المشروبات.',
          'الحديد في المقاعد والأسوار.',
          'النحاس في الأسلاك الكهربائية.'
        ]
      }
    ],
    facts: [
      'منجم السكري هو أكبر منجم ذهب في مصر.',
      'الفوسفات مادة أساسية لصناعة الأسمدة الزراعية.',
      'الحديد عنصر مهم لبناء الجسور والمباني.',
      'النحاس يوصل الكهرباء أفضل من الحديد.',
      'المعادن تتكون عبر ملايين السنين.',
      'التعدين يجب أن يراعي حماية البيئة.',
      'بعض المعادن تُستخرج من الصحراء الشرقية وسيناء.',
      'إعادة التدوير تقلل الحاجة لمناجم جديدة.'
    ],
    glossary: [
      { term: 'منجم', definition: 'مكان يُستخرج منه المعدن.' },
      { term: 'خام', definition: 'الصخر الذي يحتوي على المعدن قبل تنقيته.' },
      { term: 'فوسفات', definition: 'معدن يُستخدم في صناعة الأسمدة.' },
      { term: 'سبائك', definition: 'خليط من معادن مختلفة.' },
      { term: 'تعدين', definition: 'عملية استخراج المعادن من باطن الأرض.' }
    ],
    activities: [
      'ارسم خريطة مبسطة لمصر وضع علامة على أماكن الذهب والفوسفات.',
      'اجمع أشياء معدنية من المنزل وصنفها حسب النوع (حديد/نحاس/ألومنيوم).',
      'ناقش مع زملائك: لماذا يجب إعادة تدوير المعادن؟',
      'اصنع ملصقًا يوضح استخدامات النحاس في حياتنا.',
      'اكتب 3 جمل عن دور الفوسفات في الزراعة.'
    ],
    questions: {
      mcq: [
        {
          q: 'أي من هذه المعادن يُستخدم في صناعة الأسمدة؟',
          options: ['الذهب', 'الفوسفات', 'الحديد', 'النحاس'],
          answer: 1,
          explanation: 'الفوسفات هو المكون الأساسي للأسمدة الزراعية.'
        },
        {
          q: 'أكبر منجم ذهب في مصر هو…',
          options: ['أبو طرطور', 'السكري', 'الواحات', 'الفيوم'],
          answer: 1,
          explanation: 'منجم السكري هو الأشهر والأكبر للذهب.'
        },
        {
          q: 'أي معدن يُستخدم كثيرًا في الأسلاك الكهربائية؟',
          options: ['النحاس', 'الذهب', 'الرخام', 'الزنك'],
          answer: 0,
          explanation: 'النحاس موصل ممتاز للكهرباء.'
        },
        {
          q: 'المعادن موارد…',
          options: ['متجددة بسرعة', 'غير متجددة', 'تتكون كل سنة', 'مصنوعة في المصانع'],
          answer: 1,
          explanation: 'المعادن تتكون في الطبيعة عبر فترات طويلة جدًا.'
        },
        {
          q: 'أين توجد رواسب الفوسفات الشهيرة في مصر؟',
          options: ['أبو طرطور', 'الإسكندرية', 'دمياط', 'الغردقة'],
          answer: 0,
          explanation: 'أبو طرطور من أشهر مناطق الفوسفات.'
        },
        {
          q: 'الحديد يدخل في صناعة…',
          options: ['الخبز', 'الأجهزة الإلكترونية', 'المباني والجسور', 'الملابس'],
          answer: 2,
          explanation: 'الحديد أساس في البناء والصناعة الثقيلة.'
        },
        {
          q: 'أي من التالي مثال لإعادة التدوير؟',
          options: ['رمي العلب في القمامة', 'إعادة صهر العلب المعدنية', 'كسر الزجاج', 'دفن النفايات'],
          answer: 1,
          explanation: 'إعادة صهر العلب المعدنية هو شكل من أشكال إعادة التدوير.'
        },
        {
          q: 'المعدن يوجد عادة داخل…',
          options: ['السحب', 'الصخور', 'الماء فقط', 'الهواء'],
          answer: 1,
          explanation: 'المعادن غالبًا تكون داخل الصخور.'
        },
        {
          q: 'أي منطقة مصرية معروفة بتعدين الذهب؟',
          options: ['الصحراء الشرقية', 'الدلتا', 'الساحل الشمالي', 'القناة'],
          answer: 0,
          explanation: 'الصحراء الشرقية تضم مناطق تعدين الذهب.'
        },
        {
          q: 'النحاس معدن مهم لأنه…',
          options: ['خفيف جدًا', 'يصدأ سريعًا', 'يوصل الكهرباء جيدًا', 'لا يوجد في مصر'],
          answer: 2,
          explanation: 'النحاس موصل ممتاز للكهرباء.'
        }
      ],
      short: [
        { q: 'اذكر استخدامين للذهب في حياتنا.', answer: 'يُستخدم في الحُلي والإلكترونيات وصناعة بعض الأجهزة الدقيقة.' },
        { q: 'لماذا يُعد الفوسفات مهمًا للزراعة؟', answer: 'لأنه يدخل في صناعة الأسمدة التي تساعد النباتات على النمو.' },
        { q: 'كيف نحافظ على الثروة المعدنية؟', answer: 'بالاستخدام الرشيد وإعادة التدوير وتقليل التلوث.' },
        { q: 'اكتب اسم معدن يوجد في سيناء.', answer: 'النحاس من المعادن المعروفة في سيناء.' },
        { q: 'ما الفرق بين الخام والمعدن النقي؟', answer: 'الخام يحتوي على المعدن داخل الصخر، والمعدن النقي بعد التنقية.' },
        { q: 'اذكر ثلاثة أشياء معدنية في المنزل.', answer: 'ملاعق، أسلاك كهرباء، أبواب معدنية (أو أي أمثلة صحيحة).' },
        { q: 'لماذا تعتبر المعادن موارد غير متجددة؟', answer: 'لأنها تحتاج ملايين السنين لتتكون.' },
        { q: 'اكتب جملة عن أهمية الحديد.', answer: 'الحديد ضروري للبناء وصناعة الجسور والسيارات.' }
      ]
    },
    media: [
      {
        src: '/الدرسالاول الجديد/صور للدرس/منجم السكرى.jpg',
        caption: 'منجم السكري من أشهر مناجم الذهب في مصر.'
      },
      {
        src: '/الدرسالاول الجديد/صور للدرس/السكرى 3.jpg',
        caption: 'مشهد من منطقة التعدين في الصحراء الشرقية.'
      },
      {
        src: '/الدرسالاول الجديد/صور للدرس/اول-من-استخدم-النحاس-في-مصر-قبل-الميلاد-.jpg',
        caption: 'النحاس معدن قديم استخدمه المصريون القدماء.'
      }
    ]
  },
  'lesson-2': {
    grade: 'الصف الخامس والسادس',
    unit: 'الوحدة التجريبية (3 دروس)',
    summary: 'نتعرف في هذا الدرس على مصادر الطاقة المختلفة في مصر وكيف نستخدم الطاقة بطريقة آمنة وصديقة للبيئة.',
    objectives: [
      'التعرف على مصادر الطاقة التقليدية والمتجددة.',
      'تمييز الفرق بين البترول والغاز والطاقة الشمسية والرياح.',
      'استخدام خريطة مبسطة لتحديد أماكن الطاقة في مصر.',
      'التفكير في طرق ترشيد استهلاك الطاقة.'
    ],
    sections: [
      {
        title: 'مصادر الطاقة التقليدية',
        paragraphs: [
          'تشمل البترول والغاز الطبيعي، ويتم استخراجها من باطن الأرض أو من البحر.',
          'هذه المصادر مهمة لكنها غير متجددة.'
        ],
        bullets: [
          'البترول يُستخدم في الوقود والصناعة.',
          'الغاز الطبيعي أنظف من الفحم.',
          'يجب استخدام الطاقة بحكمة.'
        ]
      },
      {
        title: 'مصادر الطاقة المتجددة',
        paragraphs: [
          'تتميز الطاقة المتجددة بأنها لا تنفد بسرعة وتقلل التلوث.'
        ],
        bullets: [
          'الشمس: طاقة نظيفة ومتوفرة في مصر.',
          'الرياح: مناسبة في مناطق مثل جبل الزيت.',
          'المياه: تعتمد على السدود والمحطات الكهرومائية.'
        ]
      },
      {
        title: 'أهمية ترشيد الطاقة',
        paragraphs: [
          'ترشيد الطاقة يعني استخدامها بطريقة ذكية حتى تكفينا لفترة أطول.'
        ],
        bullets: [
          'إطفاء الأنوار غير الضرورية.',
          'استخدام الأجهزة الموفرة للطاقة.',
          'الاعتماد على الطاقة المتجددة عند الإمكان.'
        ]
      },
      {
        title: 'الطاقة في حياتنا اليومية',
        paragraphs: [
          'نستخدم الطاقة في الإضاءة، وتشغيل الأجهزة، والمواصلات، وحتى اللعب.'
        ],
        bullets: [
          'الطاقة تحرك الحافلات والقطارات.',
          'الطاقة ضرورية للتعلم والعمل.',
          'كل فرد مسؤول عن ترشيد الطاقة.'
        ]
      }
    ],
    facts: [
      'مصر من أغنى الدول بالشمس طوال العام.',
      'حقل ظهر من أكبر حقول الغاز في البحر المتوسط.',
      'الطاقة الشمسية تقلل انبعاثات الكربون.',
      'طاقة الرياح تستخدم التوربينات الكبيرة.',
      'الكهرباء تصل إلى بيوتنا عبر أسلاك ومحولات.',
      'محطات الطاقة الكهرومائية تعتمد على المياه الجارية.',
      'ترشيد الطاقة يوفر المال ويحافظ على البيئة.',
      'الطاقة المتجددة لا تنفد بسهولة.'
    ],
    glossary: [
      { term: 'طاقة متجددة', definition: 'طاقة تتجدد باستمرار مثل الشمس والرياح.' },
      { term: 'بترول', definition: 'سائل أسود يستخدم كوقود.' },
      { term: 'غاز طبيعي', definition: 'غاز نظيف نسبيًا يُستخدم للطهي والكهرباء.' },
      { term: 'توربين', definition: 'آلة تدور لتوليد الكهرباء من الرياح أو المياه.' },
      { term: 'ترشيد', definition: 'استخدام شيء بطريقة ذكية لتقليل الهدر.' }
    ],
    activities: [
      'ارسم شمسًا كبيرة واكتب حولها فوائد الطاقة الشمسية.',
      'اكتب قائمة بـ 5 طرق لترشيد الكهرباء في البيت.',
      'شاهد صورة محطة رياح واصنع ملخصًا قصيرًا عنها.',
      'اصنع نموذجًا ورقيًا لتوربين رياح.',
      'قارن بين الطاقة المتجددة والطاقة التقليدية في جدول.'
    ],
    questions: {
      mcq: [
        {
          q: 'أي مصدر طاقة متجدد؟',
          options: ['الفحم', 'البترول', 'الشمس', 'الغاز الطبيعي'],
          answer: 2,
          explanation: 'الشمس مصدر متجدد لا ينفد بسرعة.'
        },
        {
          q: 'الغاز الطبيعي يُعد…',
          options: ['أكثر تلوثًا من الفحم', 'أنظف من الفحم', 'غير مهم', 'لا يُستخدم في مصر'],
          answer: 1,
          explanation: 'الغاز الطبيعي أنظف من الفحم من حيث الانبعاثات.'
        },
        {
          q: 'محطات الرياح تعتمد على…',
          options: ['الشموع', 'الهواء المتحرك', 'النفط', 'الخشب'],
          answer: 1,
          explanation: 'الرياح هي الهواء المتحرك الذي يدير التوربينات.'
        },
        {
          q: 'أين يمكن استغلال الطاقة الشمسية بكفاءة في مصر؟',
          options: ['السواحل فقط', 'الصحراء', 'الجبال الثلجية', 'الأماكن الممطرة دائمًا'],
          answer: 1,
          explanation: 'الصحراء تتميز بشمس قوية طوال العام.'
        },
        {
          q: 'ترشيد الطاقة يعني…',
          options: ['إهدار الكهرباء', 'استخدام الطاقة بحكمة', 'إطفاء كل الأجهزة دائمًا', 'عدم استخدام الكهرباء'],
          answer: 1,
          explanation: 'الترشيد هو الاستخدام الذكي وتقليل الهدر.'
        },
        {
          q: 'حقل ظهر مرتبط بـ…',
          options: ['الذهب', 'الغاز الطبيعي', 'الفوسفات', 'النحاس'],
          answer: 1,
          explanation: 'حقل ظهر من أكبر حقول الغاز.'
        },
        {
          q: 'الكهرباء تصل إلى المنازل عبر…',
          options: ['الأنهار', 'الأسلاك والمحولات', 'الجبال', 'الرمال'],
          answer: 1,
          explanation: 'شبكة الكهرباء تنقل الطاقة عبر أسلاك ومحولات.'
        },
        {
          q: 'الطاقة الكهرومائية تعتمد على…',
          options: ['الرياح', 'المياه الجارية', 'الشمس', 'الوقود'],
          answer: 1,
          explanation: 'المياه الجارية تدير التوربينات في السدود.'
        },
        {
          q: 'أي سلوك يوفر الطاقة؟',
          options: ['ترك الأنوار مضاءة', 'فتح الأجهزة دون استخدام', 'إطفاء الأجهزة بعد الاستخدام', 'تشغيل المكيف والنوافذ مفتوحة'],
          answer: 2,
          explanation: 'إطفاء الأجهزة يقلل الاستهلاك.'
        },
        {
          q: 'الطاقة المتجددة مهمة لأنها…',
          options: ['تزيد التلوث', 'تنفد بسرعة', 'صديقة للبيئة', 'لا تصلح للاستخدام'],
          answer: 2,
          explanation: 'تساعد على تقليل التلوث وحماية البيئة.'
        }
      ],
      short: [
        { q: 'اذكر مثالين للطاقة المتجددة.', answer: 'الطاقة الشمسية وطاقة الرياح (أو الكهرومائية).' },
        { q: 'ما فائدة ترشيد الكهرباء؟', answer: 'يوفر المال ويحافظ على البيئة ويقلل الضغط على الموارد.' },
        { q: 'أين يُستخدم البترول؟', answer: 'في الوقود والصناعة والنقل.' },
        { q: 'كيف تساعدنا الشمس في توليد الكهرباء؟', answer: 'من خلال الألواح الشمسية التي تحول الضوء إلى كهرباء.' },
        { q: 'اكتب جملة عن أهمية الغاز الطبيعي.', answer: 'الغاز الطبيعي مصدر مهم للطاقة وأقل تلوثًا من الفحم.' },
        { q: 'اذكر سلوكًا واحدًا لترشيد الطاقة.', answer: 'إطفاء الأنوار عند مغادرة الغرفة.' },
        { q: 'ما الفرق بين الطاقة المتجددة والتقليدية؟', answer: 'المتجددة لا تنفد سريعًا، والتقليدية موارد محدودة.' },
        { q: 'لماذا تعد مصر مناسبة للطاقة الشمسية؟', answer: 'لأنها تتمتع بساعات سطوع طويلة على مدار العام.' }
      ]
    },
    media: [
      {
        src: '/الدرسالاول الجديد/صور للدرس/حقل الغاز.png',
        caption: 'حقل غاز يمثل مصدر طاقة مهم.'
      },
      {
        src: '/الدرس الثانى الجديد/صورة لمصادر الطاقة.jpg',
        caption: 'مصادر طاقة مختلفة في مصر.'
      },
      {
        src: '/الدرس الثانى الجديد/صوره للشمس.jfif',
        caption: 'الطاقة الشمسية من أهم مصادر الطاقة المتجددة.'
      }
    ]
  },
  'lesson-3': {
    grade: 'الصف الخامس والسادس',
    unit: 'الوحدة التجريبية (3 دروس)',
    summary: 'يتناول هذا الدرس دورة المياه في مصر وأهمية نهر النيل والري والمحاصيل الزراعية الأساسية.',
    objectives: [
      'التعرف على مصادر المياه في مصر.',
      'فهم أهمية نهر النيل في الزراعة والحياة اليومية.',
      'تمييز أهم المحاصيل الزراعية.',
      'تعزيز الوعي بالحفاظ على المياه.'
    ],
    sections: [
      {
        title: 'مصادر المياه في مصر',
        paragraphs: [
          'أهم مصادر المياه هي نهر النيل، المياه الجوفية، ومياه الأمطار المحدودة.',
          'تعتمد الزراعة في مصر على المياه بشكل أساسي.'
        ],
        bullets: [
          'النيل شريان الحياة في مصر.',
          'المياه الجوفية مهمة في الواحات.',
          'الأمطار قليلة في معظم المناطق.'
        ]
      },
      {
        title: 'الري والزراعة',
        paragraphs: [
          'الري ينقل الماء إلى الحقول حتى تنمو النباتات.',
          'هناك طرق حديثة للري تساعد على توفير المياه.'
        ],
        bullets: [
          'الري بالغمر طريقة قديمة.',
          'الري بالتنقيط يوفر المياه.',
          'تطوير الري يحسن الإنتاج الزراعي.'
        ]
      },
      {
        title: 'أهم المحاصيل',
        paragraphs: [
          'تشتهر مصر بزراعة القمح والأرز والقطن والذرة والفواكه والخضروات.'
        ],
        bullets: [
          'القمح غذاء أساسي.',
          'القطن المصري مشهور عالميًا.',
          'الأرز يزرع بكثرة في الدلتا.'
        ]
      },
      {
        title: 'حماية المياه',
        paragraphs: [
          'الحفاظ على الماء واجب لأن المياه ثروة مهمة يجب ألا نهدرها.'
        ],
        bullets: [
          'إغلاق الصنبور عند عدم الحاجة.',
          'عدم تلويث النيل.',
          'استخدام طرق ري حديثة.'
        ]
      }
    ],
    facts: [
      'النيل أطول نهر في أفريقيا.',
      'دلتا النيل من أخصب مناطق الزراعة.',
      'الري بالتنقيط يقلل فقد المياه.',
      'القطن المصري طويل التيلة مشهور بجودته.',
      'تلوث المياه يؤثر على صحة الإنسان.',
      'المياه الجوفية مصدر مهم في الواحات.',
      'ترشيد الماء يحافظ على الموارد للأجيال القادمة.',
      'الزراعة توفر الغذاء والمواد الخام.'
    ],
    glossary: [
      { term: 'ري', definition: 'إيصال الماء للأرض الزراعية.' },
      { term: 'دلتا', definition: 'الأرض التي تتفرع فيها فروع النيل قبل البحر.' },
      { term: 'مياه جوفية', definition: 'مياه مخزنة تحت سطح الأرض.' },
      { term: 'محصول', definition: 'النبات الذي يزرعه الفلاح للاستفادة منه.' },
      { term: 'ترشيد الماء', definition: 'استخدام الماء بحكمة لتقليل الهدر.' }
    ],
    activities: [
      'اصنع لوحة صغيرة تشرح دورة المياه في الطبيعة.',
      'اكتب قائمة بالمحاصيل التي تعرفها في منطقتك.',
      'ناقش مع أسرتك طرق توفير الماء في المنزل.',
      'ارسم خريطة للنيل وفروعه الرئيسية.',
      'قارن بين الري بالغمر والري بالتنقيط.'
    ],
    questions: {
      mcq: [
        {
          q: 'أهم مصدر للمياه في مصر هو…',
          options: ['البحر الأحمر', 'نهر النيل', 'الأمطار الغزيرة', 'الثلوج'],
          answer: 1,
          explanation: 'النيل هو المصدر الرئيسي للمياه في مصر.'
        },
        {
          q: 'أي طريقة ري توفر الماء أكثر؟',
          options: ['الري بالغمر', 'الري بالتنقيط', 'ترك الحقول بدون ري', 'الري عشوائيًا'],
          answer: 1,
          explanation: 'الري بالتنقيط يقلل فقد المياه.'
        },
        {
          q: 'القطن المصري مشهور لأنه…',
          options: ['قصير التيلة', 'طويل التيلة', 'لا يُزرع في مصر', 'عديم الجودة'],
          answer: 1,
          explanation: 'القطن المصري طويل التيلة ومشهور عالميًا.'
        },
        {
          q: 'أي من التالي محصول يُزرع في الدلتا بكثرة؟',
          options: ['الأرز', 'التمور فقط', 'الشاي', 'الكافيار'],
          answer: 0,
          explanation: 'الأرز من أهم محاصيل الدلتا.'
        },
        {
          q: 'المياه الجوفية توجد…',
          options: ['فوق السطح', 'داخل السحب', 'تحت الأرض', 'داخل الصخور البركانية فقط'],
          answer: 2,
          explanation: 'المياه الجوفية مخزنة تحت سطح الأرض.'
        },
        {
          q: 'من صور الحفاظ على الماء…',
          options: ['ترك الصنبور مفتوحًا', 'إلقاء القمامة في النيل', 'إغلاق الصنبور بعد الاستخدام', 'غسل السيارة يوميًا'],
          answer: 2,
          explanation: 'إغلاق الصنبور يقلل الهدر.'
        },
        {
          q: 'الدلتا هي…',
          options: ['صحراء واسعة', 'منطقة تفرع النيل قبل البحر', 'جبال مرتفعة', 'بحيرة ملحية'],
          answer: 1,
          explanation: 'الدلتا منطقة تفرع النهر قبل البحر.'
        },
        {
          q: 'أي من التالي يعتمد على الماء بشكل أساسي؟',
          options: ['الزراعة', 'الطيران', 'الفضاء', 'الرسم'],
          answer: 0,
          explanation: 'الزراعة تحتاج الماء لنمو النبات.'
        },
        {
          q: 'تلوث المياه يؤدي إلى…',
          options: ['زيادة جودة المياه', 'مشاكل صحية', 'زيادة الإنتاج دائمًا', 'عدم تأثير'],
          answer: 1,
          explanation: 'تلوث المياه يسبب مشكلات صحية.'
        },
        {
          q: 'أي من التالي مثال لمحصول غذائي؟',
          options: ['القمح', 'الحديد', 'الذهب', 'الغاز'],
          answer: 0,
          explanation: 'القمح محصول غذائي أساسي.'
        }
      ],
      short: [
        { q: 'اذكر مصدرين للمياه في مصر.', answer: 'نهر النيل والمياه الجوفية (وأيضًا الأمطار المحدودة).' },
        { q: 'لماذا يُعد النيل مهمًا لمصر؟', answer: 'لأنه المصدر الرئيسي للمياه والشرب والزراعة.' },
        { q: 'اكتب طريقة واحدة لتوفير الماء.', answer: 'إغلاق الصنبور عند عدم الحاجة.' },
        { q: 'ما فائدة الري بالتنقيط؟', answer: 'يوفر الماء ويوصل الماء مباشرة إلى جذور النبات.' },
        { q: 'اذكر محصولين زراعيين مشهورين في مصر.', answer: 'القمح والقطن (أو الأرز والذرة).' },
        { q: 'كيف يؤثر تلوث المياه على الإنسان؟', answer: 'يسبب أمراضًا ويؤثر على صحة الناس.' },
        { q: 'ما المقصود بالمياه الجوفية؟', answer: 'مياه مخزنة تحت سطح الأرض.' },
        { q: 'اكتب جملة عن أهمية الزراعة.', answer: 'الزراعة توفر الغذاء والمواد الخام وتدعم الاقتصاد.' }
      ]
    },
    media: [
      {
        src: '/الدرس الثانى الجديد/صورة للأراضى الزراعية.jpg',
        caption: 'الأراضي الزراعية في الدلتا مصدر غذاء مهم.'
      },
      {
        src: '/الدرس الثانى الجديد/صورة للأراضى الزراعية 2.jfif',
        caption: 'محاصيل متنوعة تحتاج إلى ري منتظم.'
      },
      {
        src: '/الدرس الثانى الجديد/صورة للمياه المالحة.jpg',
        caption: 'المياه المالحة تختلف عن المياه العذبة في الاستخدام.'
      }
    ]
  }
};
